import { useQuery } from '@hooks/reactQuery';
import { useQueryUser } from '@hooks/useQueryUser';

import { getOranUserGroupsForAlarms } from '@api/oranAlarms';

import { optionsFormattedByTitleName } from '@utils/formatter';

import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles, EVendorsValues } from '@enums/common';

import { ORAN_USER_GROUPS_FOR_ALARMS } from '@constants/queryKeys';

interface IUseQueryOranUserGroupsForAlarmsReturn {
	oranUserGroupsOptions: TSelectOptionType[];
	isLoadingOranUserGroupsOptions: boolean;
}

export const useQueryOranUserGroupsForAlarms = (): IUseQueryOranUserGroupsForAlarmsReturn => {
	const { user } = useQueryUser();
	const isOranVendor = user
		?.organization
		?.availableVendors
		.some(({ name }) => name === EVendorsValues.oran);

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [ORAN_USER_GROUPS_FOR_ALARMS],
		queryFn: getOranUserGroupsForAlarms,
		select: (data) => optionsFormattedByTitleName(data, true),
		enabled: [isOranVendor],
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
	});

	return {
		oranUserGroupsOptions: data || [],
		isLoadingOranUserGroupsOptions: isLoading && isFetching,
	};
};
